import { useState, useEffect, useContext } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppContext, SttList, SttLabelPeriod, SttChipPForm } from '../all';
import { formatPriceByLocale } from '../../lib/utils';

type FeeSlot = {
    id: number;
};

type Fee = {
    id?: number;
    feeslot: FeeSlot;
    ini: string;
    end: string;
    price: number;
    paymentForm?: string;
    priceShape?: {
        currency?: string;
        locale?: string;
    };
};

type Props = {
    fees: Fee[];
};

/**
 * Fee list
 * ========
 *
 * Props
 *
 *         * Array fees
 *
 */
export function SttFeeList({ fees }: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [feesValues, setFeesValues] = useState<Fee[]>(fees);

    /**
     * Generate fee
     */
    const generateFee = (fee: Fee, feeIndex: number) => {
        cxt?.api('POST', `/feeslot/${fee.feeslot.id}/fees`, {
            // confirmation: true,
            params: { dates: [fee.ini] },
            success: (r: { fees: Fee[] }) => {
                const newFees = [...feesValues];
                newFees[feeIndex] = Object.assign(fee, r.fees[0]);
                setFeesValues(newFees);
            },
        });
    };

    useEffect(() => {
        setFeesValues(fees);
    }, [fees]);

    // -----| Render |-----
    return (
        <SttList
            numRows={5}
            data={
                feesValues &&
                feesValues.map((fee: any, feeIndex: any) => ({
                    caption: (
                        <Grid container spacing={3}>
                            <Grid sx={{ textAlign: 'left' }} size={{ xs: 5 }}>
                                <SttLabelPeriod ini={fee.ini} end={fee.end} />
                            </Grid>
                            <Grid sx={{ textAlign: 'center' }} size={{ xs: 4 }}>
                                {fee.id ? (
                                    <SttChipPForm pf={fee.paymentForm} />
                                ) : (
                                    <a
                                        onClick={() =>
                                            generateFee(fee, feeIndex)
                                        }
                                    >
                                        {t('common.generate')}
                                    </a>
                                )}
                            </Grid>
                            <Grid sx={{ textAlign: 'right' }} size={{ xs: 3 }}>
                                <b>
                                    {formatPriceByLocale(
                                        fee.price,
                                        fee?.priceShape?.currency,
                                        fee?.priceShape?.locale,
                                    )}
                                </b>
                            </Grid>
                        </Grid>
                    ),
                }))
            }
        />
    );
}
